import React from "react";
import { FormMapperApp, type FormalizrForm } from "@types";

import DynamicsScriptLoader from "./ScriptLoader";
import DynamicsForm from "./DynamicsForm";

type FormalizrDynamicsProps = {
    form: FormalizrForm;
    locale: string;
    mapperData: FormMapperApp;
};

const FormalizerDynamics = ({
    form,
    locale,
    mapperData,
}: FormalizrDynamicsProps) => {
    const { properties } = form.output.data;

    const getDynamicsFields = () => {
        const keys = Object.keys(properties);

        return keys.map(key => ({
            name: key,
            value: properties[key].default ?? "",
            enum: properties[key].items?.enum,
        }));
    };

    return (
        <>
            <DynamicsForm
                fields={getDynamicsFields()}
                locale={locale}
                mapperData={mapperData}
                name={form.internalData.name}
            />
            <DynamicsScriptLoader />
        </>
    );
};

export default FormalizerDynamics;
